import { render, staticRenderFns } from "./addFee.vue?vue&type=template&id=5ea04d86&scoped=true"
import script from "./addFee.vue?vue&type=script&lang=js"
export * from "./addFee.vue?vue&type=script&lang=js"
import style0 from "./addFee.vue?vue&type=style&index=0&id=5ea04d86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea04d86",
  null
  
)

export default component.exports